"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../theme");
var useStyles = (0, _theme.makeStyles)({
  content: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  vertical: {
    flexDirection: 'column',
    '& $input': {
      width: '100%',
      marginBottom: 8
    }
  },
  input: {
    width: 'calc(50% - 8px)'
  }
}, {
  name: 'DateRangePicker'
});
exports.useStyles = useStyles;